<template>
  <div class="reject">
    <Field v-model="content" rows="6" autosize type="textarea" :placeholder="$t('option.reject.content')" />

    <div class="button">
      <Button color="#00CCBF" @click="submit" block>{{ $t('common.submit') }}</Button>
    </div>
  </div>
</template>

<script>
import { Field, Button, Toast, Notify } from 'vant';
import api from '@/services/api';
export default {
  components: {
    Field,
    Button,
  },
  data() {
    return {
      loading: true,
      list: [],
      content: '',
    };
  },
  computed: {
    select() {
      return this.$route.params.select;
    },
    url() {
      return this.$route.path;
    },
    historySelect() {
      return window.history.state && window.history.state.select;
    },
  },
  methods: {
    initState() {
      if (this.select) {
        window.history.replaceState(
          {
            select: this.select,
          },
          this.url
        );
      }
    },
    submit() {
      if (!this.auth()) return;
      Toast.loading({
        duration: 0,
        forbidClick: true,
        message: this.$t('empty.loading') + '...',
      });
      api
        .review({
          uniqueIds: this.historySelect.join(','),
          remark: this.content,
          verifyStatus: 2,
          deviceIds: '',
        })
        .then(res => {
          Toast.clear();
          const [success] = res;
          if (success) {
            this.$router.push({ name: 'visitorOptionResult' });
          }
        });
    },
    auth() {
      if (!this.historySelect) {
        Notify({
          type: 'warning',
          message: this.$t('option.reject.select.tips'),
        });
        return false;
      }

      if (!this.content) {
        Notify({
          type: 'warning',
          message: this.$t('option.reject.content.tips'),
        });
        return false;
      }

      return true;
    },
  },
  mounted() {
    this.initState();
  },
};
</script>

<style lang="less" scoped>
.reject {
  margin-top: 16px;

  .button {
    position: fixed;
    height: 98px;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: white;
    padding: 0 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
